module.exports = __webpack_public_path__ + "img/img-3-mobile.4f4ab535.webp";